











































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { MessageTemplate, TemplateTagLink } from '@/communications/templates/models/message-template';
import { Reminder } from '@/communications/reminders/models/reminder-models';
import { Org } from '@/models/organization/org';
import { Brand } from '@/organizations/brands/models/brand-models';
import EmailSubject from '@/communications/templates/components/EmailSubject.vue';
import EmailTemplateAttachments from '@/communications/templates/components/EmailTemplateAttachments.vue';
import CrmTypeSelectList from '@/crm-types/components/CrmTypeSelectList.vue';
import EmailTemplateTags from '@/communications/templates/components/EmailTemplateTags.vue';
import { CrmTypeList, CrmTypeOption } from '@/crm-types/models/crm-type';
import {
    HIERARCHY_TYPE_BRAND_ID,
    HIERARCHY_TYPE_LOCATION_GROUP_ID,
    HIERARCHY_TYPE_LOCATION_ID
} from '@/crm-types/crm-types-constants';
import {
    buildOrgsWithCorporateOptions,
    getSelectedOrgValue,
    handleOrgValueSelection,
    CORPORATE_ONLY_VALUE,
    OrgOption
} from '@/communications/templates/text-template-utils';

@Component({
    components: {
        EmailSubject,
        EmailTemplateAttachments,
        EmailTemplateTags,
        CrmTypeSelectList
    }
})
export default class EmailTemplateHeaderCard extends Vue {
    @Prop({ required: false }) id: number | undefined;
    @Prop({ required: true }) messageTemplate!: MessageTemplate | Reminder;
    @Prop({ required: true }) isTemplate!: boolean;
    @Prop({ required: true }) isPreviewOnly!: boolean;
    @Prop({ required: true }) canSeeHierarchyFields!: boolean;
    @Prop({ required: true }) isNewMarketingTemplates!: boolean;
    @Prop({ required: true }) requiredField!: Array<Function>;
    @Prop({ required: true }) hasCommunicationTypes!: boolean;
    @Prop({ required: true }) communicationTypeOptions!: Array<CrmTypeOption>;
    @Prop({ required: true }) communicationType!: number | null;
    @Prop({ required: true }) areTemplateGroupsEnabled!: boolean;
    @Prop({ required: true }) templateGroups!: Array<CrmTypeOption>;
    @Prop({ required: true }) templateGroupId!: number | null;
    @Prop({ required: true }) areTagsEnabled!: boolean;
    @Prop({ required: false, default: () => [] }) tags!: Array<TemplateTagLink>;
    @Prop({ required: true }) hierarchyItems!: Array<CrmTypeOption>;
    @Prop({ required: true }) hierarchyTypeId!: number | null;
    @Prop({ required: true }) orgs!: Array<Org>;
    @Prop({ required: true }) orgId!: number | null;
    @Prop({ required: true }) brands!: Array<Brand>;
    @Prop({ required: true }) brandId!: number | null;
    @Prop({ required: true }) locationGroups!: Array<CrmTypeOption>;
    @Prop({ required: true }) locationGroupId!: number | null;
    @Prop({ required: true }) canSave!: boolean;
    @Prop({ required: true }) canDeleteTemplates!: boolean;
    @Prop({ required: true }) detailsPanel!: number | undefined;
    @Prop({ required: true }) isCorporateOnly!: boolean;
    @Prop({ required: true }) isCorpLevelUser!: boolean;

    private validForm = false;
    private templateGroupsEmailList = CrmTypeList.TEMPLATE_GROUPS_EMAIL;
    private brandHierarchyTypeId = HIERARCHY_TYPE_BRAND_ID;
    private locationGroupHierarchyTypeId = HIERARCHY_TYPE_LOCATION_GROUP_ID;
    private orgHierarchyTypeId = HIERARCHY_TYPE_LOCATION_ID;
    private readonly CORPORATE_ONLY_VALUE = CORPORATE_ONLY_VALUE;

    get localMessageTemplate() {
        return this.messageTemplate;
    }

    get localCommunicationType() {
        return this.communicationType;
    }

    set localCommunicationType(value: number | null) {
        this.$emit('update:communicationType', value);
    }

    get localTemplateGroupId() {
        return this.templateGroupId;
    }

    set localTemplateGroupId(value: number | null) {
        this.$emit('update:templateGroupId', value);
    }

    get localHierarchyTypeId() {
        return this.hierarchyTypeId;
    }

    set localHierarchyTypeId(value: number | null) {
        this.$emit('update:hierarchyTypeId', value);
    }

    get localOrgId() {
        return this.orgId;
    }

    set localOrgId(value: number | null) {
        this.$emit('update:orgId', value);
    }

    get localBrandId() {
        return this.brandId;
    }

    set localBrandId(value: number | null) {
        this.$emit('update:brandId', value);
    }

    get localLocationGroupId() {
        return this.locationGroupId;
    }

    set localLocationGroupId(value: number | null) {
        this.$emit('update:locationGroupId', value);
    }

    get localDetailsPanel() {
        return this.detailsPanel;
    }

    set localDetailsPanel(value: number | undefined) {
        this.$emit('update:detailsPanel', value);
    }

    get localIsCorporateOnly() {
        return this.isCorporateOnly;
    }

    set localIsCorporateOnly(value: boolean) {
        this.$emit('update:isCorporateOnly', value);
    }

    get orgsWithCorporateOptions(): Array<OrgOption> {
        return buildOrgsWithCorporateOptions(
            this.orgs,
            this.isNewMarketingTemplates,
            this.hierarchyTypeId,
            this.orgHierarchyTypeId,
            this.isCorpLevelUser
        );
    }

    get selectedOrgValue(): number | string | null {
        return getSelectedOrgValue(
            this.orgId,
            this.isCorporateOnly,
            this.isNewMarketingTemplates,
            this.hierarchyTypeId,
            this.orgHierarchyTypeId
        );
    }

    set selectedOrgValue(value: number | string | null) {
        const result = handleOrgValueSelection(value, this.orgs);
        this.localIsCorporateOnly = result.isCorporateOnly;
        this.$emit('update:orgId', result.orgId);
    }

    @Watch('validForm')
    onValidFormChange(value: boolean) {
        this.$emit('update:validForm', value);
    }

    async confirmRemoveTag(tag: any) {
        const response = await this.$swal({
            text: `Are you sure you want to remove the tag "${tag.name}" from this template?`,
            showConfirmButton: true,
            showCancelButton: true
        });

        if (response.isConfirmed) {
            this.$emit('remove-tag', tag);
        }
    }
}
